module.exports = __webpack_public_path__ + "images/mdj/members/resume/common/common_arrow01-25aa941b57c4a6390ed48bc8271facb4.png";